module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4r8r7r-74a6449051a3f8a186c01995f4925a40.svg";